// Short lines under one of Buffy's replies (W4-B, review finding 14): how the
// reply was made, in plain words. notes: [{ key, text }]; replyNotes() in
// data/sandyApi.js builds them. Quiet gray text, no box, no button.
export default function BuffyReplyNotes({ notes }) {
  if (!notes?.length) return null;
  return <ul className="buffy-reply-notes" aria-label="About this reply">
    {notes.map((n) => <li key={n.key}>{n.text}</li>)}
  </ul>;
}
